import { render, staticRenderFns } from "./BuildStructure.vue?vue&type=template&id=662d33c8&scoped=true&"
import script from "./BuildStructure.vue?vue&type=script&lang=js&"
export * from "./BuildStructure.vue?vue&type=script&lang=js&"
import style0 from "./BuildStructure.vue?vue&type=style&index=0&id=662d33c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d33c8",
  null
  
)

export default component.exports